export enum ProcessTypes {
  RENEWAL = '1ea82e5f-8ce4-44de-b99b-0611ad7a37a6',
  APPLICATION = '05501404-cede-4867-af82-e8c13f87d153',
  VARIATION = '35449b71-1866-47d4-b488-9624debb5e3d',
}
